// `/businesses/$id` — editor route (US-106..US-117).

import { createRoute, useNavigate } from '@tanstack/react-router';

import { BusinessEditor } from '@/features/businesses/BusinessEditor';

import { Route as BusinessesLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => BusinessesLayoutRoute,
  path: '$id',
  component: BusinessesEdit,
});

function BusinessesEdit() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    <BusinessEditor
      id={id}
      onDeleted={() => {
        void navigate({ to: '/businesses' });
      }}
      onBack={() => {
        void navigate({ to: '/businesses' });
      }}
    />
  );
}
